// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"653ecaeb","431":"c64d42d9","569":"20855419","621":"0dd153ba","743":"9cfb79ac","820":"51b5cd2b"}[chunkId] + ".chunk.js";
};